import doc               from '@widesk-core/decorators/doc';
import ImportModel       from './ImportModel';

@doc.path('/imports/check')
export default class ImportCheckModel extends ImportModel {}